<template>
  <div class="wrapper">
    <h1>Häufig gestellte Fragen</h1>
    <p
      class="intro max-w-3xl mt-4"
    >Wenn wir Ihr Interesse geweckt haben, dann füllen Sie einfach das untenstehende Formular aus und schicken es ab, oder rufen Sie uns einfach an</p>
    <Accordion class="max-w-3xl mt-12" v-if="data" :data="data" />
  </div>
</template>

<script>
import Accordion from '../components/Accordion.vue'

export default {
  name: 'Faq',
  components: {
    Accordion,
  },
  data() {
    return {
      data: [
        {
          title: 'Was gibt es bzgl. der Heizung zu beachten?',
          content:
            'the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        },
        {
          title: 'Wie funktioniert der Ofen im Aufenthaltsraum?',
          content:
            'the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        },
        {
          title: 'Muss die Türe im 1.OG Dauerhaft geöffnet bleiben?',
          content:
            'the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        },
        {
          title: 'Gibt es auf der Hütte W-Lan?',
          content:
            'the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        },
      ],
    }
  },
}
</script>
